import React, { useState, useEffect } from 'react'
import { Input, Form, Tooltip, Popover } from 'antd'
import { ReactComponent as DeleteIcon } from '../../../../../../assets/images/form_icons/MoreOptionsIcons/deleteIcon.svg'
import { ReactComponent as EditIcon } from '../../../../../../assets/images/form_icons/MoreOptionsIcons/editIcon.svg'
import { ReactComponent as SaveIcon } from '../../../../../../assets/images/form_icons/MoreOptionsIcons/saveIcon.svg'

import style from './props.module.sass'
// import EditCreateTeam from '../../../../organization/teams/editCreateTeam'

interface IProps {
    option: any,
    options: any[],
    updateOptions: (data: any, key: string) => void,
    canEdit?: boolean,
}

export const ListLabelValue = (props: IProps) => {
    const { canEdit = true } = props

    const option = props.option
    const options = props.options

    const [isEdit, setEdit] = useState(false)

    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')

    const [labelErr, setLabelErr] = useState(false)
    const [valueErr, setValueErr] = useState(false)

    const [labelErrPopup, setLabelErrPopup] = useState(false)
    const [valueErrPopup, setValueErrPopup] = useState(false)

    useEffect(() => {
        setLabel(option.label)
        setValue(option.value)
    }, [option])


    const checkIfPresent = (id: number, range: any[], key: any, prop: any) => {
        const updatedOptions = range.filter((item) => item.id !== option.id)
        return updatedOptions.find((el) => el[`${key}`].toLowerCase() === prop.toLowerCase())
    }

    const deleteOption = () => {
        const updatedOptions = options.filter((item) => item.id !== option.id)
        props.updateOptions(updatedOptions, 'data.options')
    }

    const editOption = () => {
        //On Save
        if (isEdit) {
            const labelPresent = checkIfPresent(option.id, options, 'label', label)
            const valuePresent = checkIfPresent(option.id, options, 'value', value)

            setLabelErr((!label || labelPresent) ? true : false)
            setValueErr((!value || valuePresent) ? true : false)

            if ((label && value) && (!labelPresent && !valuePresent)) {
                const updatedOptions = [...options]
                updatedOptions[options.findIndex((item) => item.id === option.id)].label = label
                updatedOptions[options.findIndex((item) => item.id === option.id)].value = value
                props.updateOptions(updatedOptions, 'data.options')
                setEdit(!isEdit)
            }
        } else {
            setEdit(!isEdit)
        }

    }

    const popOverVisibleChange = (item: string, visible: boolean) => {
        //On mouse out
        if (!visible) {
            (item === 'label') ? setLabelErrPopup(false) : setValueErrPopup(false)
        } else {
            if (item === 'label') {
                (labelErr) ? setLabelErrPopup(true) : setLabelErrPopup(false)
            } else if (item === 'value') {
                (valueErr) ? setValueErrPopup(true) : setValueErrPopup(false)
            }
        }
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>

            <Form.Item className={'a8-form-item props col-md-4'}>
                <Popover
                    visible={labelErrPopup}
                    onVisibleChange={(visible) => popOverVisibleChange('label', visible)}
                    placement='topLeft'
                    trigger='hover'
                    content={(<div style={{ color: '#ff7e7a', padding: '10px' }}>{label ? 'Label exists' : 'Empty label'}</div>)}>
                    <Input data-test-id="label" className={`${labelErr ? style.inputError : style.input} ${style.borderRemove}`}
                        disabled={!isEdit || !canEdit}
                        placeholder="Label"
                        value={label}
                        onChange={(e) => {
                            setLabel(e.target.value)
                            setLabelErr(false)
                            setLabelErrPopup(false)
                        }} />
                </Popover>
            </Form.Item>

            <Form.Item className={'a8-form-item props col-md-4'}>
                <Popover
                    visible={valueErrPopup}
                    onVisibleChange={(visible) => popOverVisibleChange('value', visible)}
                    placement='topLeft'
                    trigger='hover'
                    content={(<div style={{ color: '#ff7e7a', padding: '10px' }}>{value ? 'Value exists' : 'Empty value'}</div>)}>
                    <Input data-test-id="value" className={`${valueErr ? style.inputError : style.input} ${style.borderRemove}`}
                        disabled={!isEdit || !canEdit}
                        placeholder="Value"
                        value={value}
                        onChange={(e) => {
                            setValue(e.target.value)
                            setValueErr(false)
                            setValueErrPopup(false)
                        }} />
                </Popover>
            </Form.Item>

            {/* <Tooltip title={isEdit?'Save':'Edit'} placement='topLeft'>
                <Button onClick={editOption} type='default' style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <Icon onClick={editOption}
                        className="dynamic-delete-button"
                        type={isEdit?'save':'edit'}
                    />
                </Button>
            </Tooltip> */}
            {isEdit && canEdit ?
                <Tooltip title='Save' placement='top'>
                    <SaveIcon data-test-id="save" onClick={editOption} height='20px' width='20px' style={{ marginBottom: '20px', cursor: 'pointer' }}></SaveIcon>
                </Tooltip>
                :
                <Tooltip title='Edit' placement='top'>
                    <EditIcon data-test-id="edit" onClick={editOption} height='20px' width='20px' style={{ marginBottom: '20px', cursor: 'pointer' }}></EditIcon>
                </Tooltip>
            }
            <Tooltip title='Delete' placement='top'>
                <DeleteIcon data-test-id="delete" onClick={() => canEdit && deleteOption()} height='20px' width='20px' style={{ marginBottom: '20px', cursor: 'pointer' }}></DeleteIcon>
            </Tooltip>
            {/* <Tooltip title='Delete' placement='topRight'>
                <Button onClick={deleteOption} type='default' style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <Icon
                        className="dynamic-delete-button"
                        type="minus"
                    />
                </Button>
            </Tooltip> */}

        </div>
    )
}
